import * as Business            from '../business';
import * as User                from '../user';
import { connect }              from 'react-redux';
import { PageContent }          from 'framework7-react';
import ChatGroups               from './chat_groups';
import ChatRooms                from './chat_rooms';
import PropTypes                from 'prop-types';
import React                    from 'react';
import ResourceUnavailableImage from '../assets/images/resource-unavailable.svg';
import TabPage                  from '../components/tab_page';
import WaitForTwilio            from './wait_for_twilio';
import withMainRouteParams      from '../components/with_main_route_params';


function TeamChatTab({ businessID, business, conversationID, userID, isSalesforceUser, users, rooms }) {
  return (
    <TabPage name="messages" title="Team Chat">
      <PageContent>
        {business && <TabContent {...{ businessID, conversationID, userID, isSalesforceUser, users, rooms }}/>}
      </PageContent>
    </TabPage>
  );
}

export default withMainRouteParams(
  connect(
    (state, { businessID, conversationID }) => ({
      businessID,
      conversationID,
      isSalesforceUser: User.isSalesforce(state),
      userID:           User.getUserID(state),
      rooms:            Business.getRooms(state, businessID),
      users:            Business.getUsers(state, businessID),
      business:         Business.getBusiness(state, businessID)
    })
  )(TeamChatTab)
);


TeamChatTab.propTypes = {
  businessID: PropTypes.string.isRequired,
  users:      PropTypes.array,
  rooms:      PropTypes.array
};

function TabContent({ businessID, conversationID, userID, isSalesforceUser, users, rooms }) {
  const isImpersonatingUser = (isSalesforceUser && userID);
  const isSupported         = (isImpersonatingUser || !isSalesforceUser);

  if (!isSupported)
    return <TeamChatUnavailable/>;

  return (
    <WaitForTwilio>
      <div className="conversations-list twilio-tab">
        <ChatRooms businessID={businessID} conversationID={conversationID} rooms={rooms}/>
        <ChatGroups businessID={businessID} conversationID={conversationID} userID={userID} users={users}/>
      </div>
    </WaitForTwilio>
  );
}

function TeamChatUnavailable() {
  return (
    <div className="resource-error">
      <ResourceUnavailableImage className="resource-unavailable__image"/>
      <h2>Team Chat is unavailable.</h2>
    </div>
  );
}
